<template>
  <v-dialog
    v-model="localValue"
    max-width="400"
  >
    <v-card>
      <v-card-title class="headline">{{!status ? 'Vklopi' : 'Izklopi'}} FURS potrjevanje</v-card-title>

      <v-card-text>
        Ali ste prepričani, da želite <b>{{status ? 'izklopiti' : 'vklopiti'}}</b> davčno potrjevanje na napravi?
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn
          color="blue-grey lighten-3"
          text
          @click="$emit('input', false); step = 1"
        >
          Prekliči
        </v-btn>

        <v-btn
          v-if="status"
          color="red darken-2"
          dark
          @click="$emit('input', false); $emit('confirmed', { deleteData: false })"
        >
          Izklopi
        </v-btn>
        <v-btn
          v-if="!status && step === 1"
          color="red darken-2"
          dark
          @click="step = 2"
        >
          Vklopi
        </v-btn>
        <v-btn
          v-if="!status && step === 2"
          color="red darken-2"
          dark
          @click="$emit('input', false); $emit('confirmed', { deleteData: false }); step = 1"
        >
          Ohrani podatke
        </v-btn>
        <v-btn
          v-if="!status && step === 2"
          color="red darken-2"
          dark
          @click="$emit('input', false); $emit('confirmed', { deleteData: true }); step = 1"
        >
          Briši podatke
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    status: {
      required: true,
      type: Boolean
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      step: 1,
      localValue: this.value
    }
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
      this.step = 1
    }
  }
}
</script>
